import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import {
  useGetModelsCarsQuery,
  useLazyGetModelTableDataQuery,
  useAppSelector,
} from '@spartalabs/pdc-core';
import { Container, MultiInfoCard, Unauthorized } from 'components';
import TableCard from 'components/Cards/TableCard';
import { ModelFilters } from 'utils/constants';
import { downloadFile } from 'utils/functions';
import { ModelTable } from './consts';

export const Models: React.FC = () => {
  const {
    data: modelsData,
    isFetching: isFetchingModels,
    isLoading: isLoadingModels,
    isError: isErrorModels,
    refetch: refetchModels,
  } = useGetModelsCarsQuery();

  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const [
    fetchTable,
    {
      data: tableData,
      isLoading: isLoadingTable,
      isFetching: isFetchingTable,
      isError: isErrorTable,
    },
  ] = useLazyGetModelTableDataQuery();

  if (!permissions?.includes('models')) return <Unauthorized />;

  return (
    <Container mt="0px" pt="0px">
      <VStack spacing="20px">
        <MultiInfoCard
          loading={isLoadingModels}
          fetching={isFetchingModels}
          canHaveShowMore
          w="100%"
          customTitle={
            <Text
              alignSelf="center"
              color="text.100"
              fontSize="16px"
              fontWeight={400}
            >
              Distribuição da <b>frota por modelo</b>
            </Text>
          }
          subtitle="Modelos e quantidade"
          data={modelsData}
          isError={isErrorModels}
          refetch={refetchModels}
        />
        <TableCard
          loading={isLoadingTable || isFetchingTable}
          fetchData={fetchTable}
          fetchDownload={async () => await downloadFile('models', 'Modelos')}
          hasGlobalSearch
          customTitle={
            <Text
              alignSelf="center"
              color="text.100"
              fontSize="16px"
              fontWeight={400}
            >
              Relatório de <b>Veículos</b>
            </Text>
          }
          subtitle="Modelos de veículos"
          overflowX="auto"
          w="100%"
          filters={ModelFilters}
          labels={ModelTable}
          data={tableData}
          analyticsId="Todos os veículos"
          isError={isErrorTable}
          refetch={fetchTable}
        />
      </VStack>
    </Container>
  );
};
